module.exports = __webpack_public_path__ + "img/percent-02.a7ca04dc.svg";